import { getToday } from '@/common/functions/getToday';
import { useRef, useState } from 'react';

const useSearchBox = ({ handleSearchCallback }) => {
	const today = getToday();

	const dateFromRef = useRef();
	const dateToRef = useRef();

	const [selectedDevice, setSelectedDevice] = useState();
	const [selectedSource, setSelectedSource] = useState();
	const [selectedDomain, setSelectedDomain] = useState();

	const handleSearch = (e) => {
		e.preventDefault();
		const dateFrom = new Date(dateFromRef.current.value).toISOString();
		const dateTo = new Date(dateToRef.current.value).toISOString();
		const domain = selectedDomain?.value;
		const device = selectedDevice?.value;
		const source = selectedSource?.value;

		handleSearchCallback(dateFrom, dateTo, domain, device, source);
	};

	return {
		today,
		dateFromRef,
		dateToRef,
		handleSearch,
		selectedDevice,
		setSelectedDevice,
		selectedSource,
		setSelectedSource,
		selectedDomain,
		setSelectedDomain,
	};
};

export default useSearchBox;
